export function Home(props) {
  return (
    <header className="pb-24 bg-grayM sm:pb-32 ">
      <div className="pt-32 max-w-md mx-auto text-center px-4 sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
        <h1 className="tracking-tighter text-4xl font-bold sm:pt-5 lg:pt-6 lg:text-5xl xl:text-6xl">
          {props.title}
        </h1>
        <p className="mt-6 text-center mx-auto text-xl max-w-3xl">{props.description}</p>
      </div>
    </header>
  );
}
